import React, { useEffect, useState } from 'react';

import { CustomButton } from '@components/Styles/ButtonStyle';
import { CustomStack } from '@components/Styles/CommonStyle';
import SelfAccountCreateTable from '@components/common/Table/SelfAccountCreateTable';
import api from '@api/axios';
import { useNavigate } from 'react-router-dom';
import { useDialog } from '@context/DialogContext';
const SelfAccountCreate = () => {
  const { showDialog } = useDialog();
  const navigate = useNavigate();

  // 개인사업자 ID
  const id = new URLSearchParams(window.location.search).get('id') || null;

  // 사업자 정보
  const [param, setParam] = useState({
    personName: '',
    companyName: '',
    companyBusinessNumber: '',
    phone: '',
    email: '',
    bank: '',
    accountNumber: '',
    identityFile: null,
    bankbookFile: null,
    businessLicenseFile: null,
  });

  // 저장
  const handleSave = () => {
    if (param.personName === '') {
      showDialog({ title: '확인', message: '이름을 입력해 주세요.' });
      return;
    }
    if (param.companyName === '') {
      showDialog({ title: '확인', message: '업체명을 입력해 주세요.' });
      return;
    }
    if (param.companyBusinessNumber === '') {
      showDialog({ title: '확인', message: '사업자번호를 입력해 주세요.' });
      return;
    }

    const identityFile = param.identityFile;
    const businessLicenseFile = param.businessLicenseFile;
    const bankbookFile = param.bankbookFile;
    const formData = new FormData();
    formData.append('identity', identityFile);
    formData.append('license', businessLicenseFile);
    formData.append('bankbook', bankbookFile);
    formData.append('param', JSON.stringify(param));

    // 신규 시 신규 업체 등록, 수정 시 수정
    let url = null;
    if (id) url = `/api/account/updateSelfAccount?id=${id}`;
    else url = '/api/account/createSelfAccount';

    api.post(url, formData).then((res) => {
        console.log('res');
        console.log(res);

        // 저장 성공 시 목록 페이지로 이동
        if (res.status === 200) navigate('/account/selfAccountList');
      })
      .catch((err) => {
        showDialog({ title: '', message: '이미 존재하는 업체입니다.', modalType: 'alert' });
        console.log('handleSave :: err');
        console.log(err);
      });
  };

  // 취소
  const handleCancel = () => {
    navigate('/account/selfAccountList');
  };

  useEffect(() => {
    if (id) {
      // 수정 시에 아이디에 맞는 데이터 조회
      api.get(`/api/account/readAccount?id=${id}`).then((res) => {
        console.log('res');
        console.log(res);

        if (res.status === 200) {
          const account = res?.data?.result?.account?.[0];
          const tempParam = {
            personName: account?.ceo_name,
            companyName: account?.company_name,
            companyBusinessNumber: account?.business_no,
            phone: account?.tel,
            email: account?.email,
            bank: account?.account_bank_name,
            accountNumber: account?.account_bank_no,
            identityFile: account?.id_card_url,
            bankbookFile: account?.bankbook_url,
            businessLicenseFile: account?.business_cert_url,
          };

          setParam(tempParam);
        }
      });
    }
  }, [id]);

  return (
    <React.Fragment>
      <SelfAccountCreateTable param={param} setParam={setParam} />
      <CustomStack justifyContent="center" mt={4}>
        <CustomButton color="gray" onClick={handleCancel}>
          취소
        </CustomButton>
        <CustomButton onClick={handleSave}>저장</CustomButton>
      </CustomStack>
    </React.Fragment>
  );
};

export default SelfAccountCreate;
